module.exports = __webpack_public_path__ + "img/5.fc95e2ea.jpg";